<template lang='pug'>
  .call-to-action
    //another-arch
    v-row(justify='center')
      v-col(cols='12' md='10' lg='8' xl='6')
        v-row(align='center' justify='center')
</template>

<script>
import AnotherArch from './AnotherArch';

export default {
  name: 'CallToAction',
  components: {AnotherArch},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .call-to-action {
    background-color: #082543;
    padding-bottom: 4vh;
  }
</style>
